import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Tooltip extends Collapsible {
  static settings = {
    control: '.js-tooltip-control',
    target: '.js-tooltip-target',
  };

  constructor(element, options = {}) {
    super(element, {
      ...Tooltip.settings,
      ...options
    });

    this._originalHelpParent = null;
    this._originalHelpNextSibling = null;
    this._tooltipButtonSpan = this.element.querySelector('.c-tooltip__button span');
    this._control = this.element.querySelector('.js-tooltip-control');

    if (this._control) {
      const newControl = this._control.cloneNode(true);
      this._control.parentNode.replaceChild(newControl, this._control);
      this._control = newControl;

      this._control.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      });
    }

    this.mount();
  }

  mount() {
    if (this._control) {
      this._control.setAttribute('aria-expanded', 'false');
    }

    const tooltipTarget = this.element.querySelector('.js-tooltip-target');
    if (tooltipTarget) {
      tooltipTarget.setAttribute('hidden', '');
      tooltipTarget.setAttribute('tabindex', '-1');
    }

    if (this._tooltipButtonSpan) {
      this._tooltipButtonSpan.textContent = 'Voir les indications supplémentaires';
    }
  }

  toggle() {
    const tooltipTarget = this.element.querySelector('.js-tooltip-target');
    const isCurrentlyOpen = this._control.getAttribute('aria-expanded') === 'true';

    if (isCurrentlyOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    console.log('tooltip open');

    const tooltipTarget = this.element.querySelector('.js-tooltip-target');
    if (!tooltipTarget) return;

    this._control.setAttribute('aria-expanded', 'true');
    tooltipTarget.removeAttribute('hidden');
    tooltipTarget.setAttribute('tabindex', '0');

    if (this._tooltipButtonSpan) {
      this._tooltipButtonSpan.textContent = 'Fermer les indications supplémentaires';
    }

    let helpElement = this.element.querySelector('.c-form-note--help');

    if (!helpElement) {
      const afterTarget = tooltipTarget.nextElementSibling;
      if (afterTarget?.classList.contains('c-form-note--help')) {
        helpElement = afterTarget;
      }
    }

    if (helpElement && !tooltipTarget.contains(helpElement)) {
      this._originalHelpParent = helpElement.parentElement;
      this._originalHelpNextSibling = helpElement.nextElementSibling;
      tooltipTarget.prepend(helpElement);
    }

    this.element.dispatchEvent(new CustomEvent('tooltip:opened'));
  }

  close() {
    console.log('tooltip close');

    const tooltipTarget = this.element.querySelector('.js-tooltip-target');
    if (!tooltipTarget) return;

    this._control.setAttribute('aria-expanded', 'false');
    tooltipTarget.setAttribute('hidden', '');
    tooltipTarget.setAttribute('tabindex', '-1');

    if (this._tooltipButtonSpan) {
      this._tooltipButtonSpan.textContent = 'Voir les indications supplémentaires';
    }

    const helpElement = this.element.querySelector('.c-form-note--help');
    if (helpElement && this._originalHelpParent) {
      if (this._originalHelpNextSibling) {
        this._originalHelpParent.insertBefore(helpElement, this._originalHelpNextSibling);
      } else {
        this._originalHelpParent.appendChild(helpElement);
      }
    }

    this.element.dispatchEvent(new CustomEvent('tooltip:closed'));
  }
}
